import apiClient from "./axiosClient"

const logout =(data)=> {
  return apiClient.post(`auth/logout`, data)
}

const verifyToken = (token) => {
  return apiClient.get(`auth/verify/${token}`)
}

const signin = (data) => {
  return apiClient.post(`auth/`, data)
}

const signInGoogle= (data) =>{
  return apiClient.post(`auth/google`, data )
}

const signup = (data) => {
  return apiClient.post(`auth/register`, data )
}

const signUpGoogle= (data) =>{
  return apiClient.post(`auth/google/register`, data )
}

const expired = (data, code) =>{
  return apiClient.post(`auth/expired/${code}`, data )
}

const activate = (data, code) =>{
  return apiClient.put(`auth/register/${code}`,data)
}

const forgotUser = (data) =>{
  return apiClient.post(`auth/forgot-password/`, data )
}

const resend = (data) =>{
  return apiClient.post(`auth/resend/`, data )
}

const account = (data) =>{
  return apiClient.get(`users/${data.id}`)
}

const updateAccount = (data) =>{
  return apiClient.put(`users/${data.id}`, data )
}

const deleteAccount = (data) =>{
  return apiClient.delete(`users/${data.id}`, data )
}

const updateProfile = (data) =>{
  return apiClient.patch(`users/${data.id}`, data )
}

const deleteProfile = (data) =>{
  return apiClient.delete(`users/${data.id}/profile`, data )
}

export { 
  signin, signInGoogle, signup, expired, verifyToken,
  signUpGoogle, logout, activate, forgotUser, resend, 
  account, updateAccount, deleteAccount, 
  updateProfile, deleteProfile
};